module.exports = __webpack_public_path__ + "img/KAEDC.30ae5e5f.svg";